export const getGender = (gender = '') =>
  gender.toLowerCase() === 'male' ? 'Männlich' : 'Weiblich';

export const getGermanLanguageLevelForStudent = (level = '') => {
  switch (level.toLowerCase()) {
    case 'little':
      return 'übersetzung notwendig';
    case 'high':
      return 'genügend bis gut';

    default:
      return level;
  }
};

export const getGermanLanguageLevel = (level = '') => {
  switch (level.toLowerCase()) {
    case 'none':
      return 'Gar Kein';
    case 'little':
      return 'Wenig';
    case 'medium':
      return 'Mittel';
    case 'high':
      return 'Viel';
    case 'fluent':
      return 'ausschliesslich';

    default:
      return level;
  }
};

export const getKnowledgeLevel = (level = '') => {
  switch (level.toLowerCase()) {
    case 'basic':
      return 'Teilweise erfüllt';
    case 'intermediate':
      return 'Erfüllt';
    case 'advanced':
      return 'Teilweise übertroffen';

    default:
      return level;
  }
};

export const getSpecialNeeds = (item = '') => {
  switch (item.toLowerCase()) {
    case 'germanassecondlanguage':
      return 'DaZ';
    case 'logopedic':
      return 'Logopädie';
    case 'psychomotor':
      return 'Psychomotorik';

    default:
      return item;
  }
};

export const getHelpWithStudy = (item = '') => {
  switch (item.toLowerCase()) {
    case 'german':
      return 'Deutsch';
    case 'maths':
      return 'Mathe';
    case 'lzagerman':
      return 'LZA Deutsch';
    case 'lzamaths':
      return 'LZA Mathe';
    default:
      return item;
  }
}
